module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/320.991cca40.png";